export default "/images/vendor/flag-icons/flags/4x3/gi.svg?b0f633cc5f004108e1ff2c213a2a919f";